import type { QueryClient } from '@tanstack/react-query';

type QueryClientFactory = () => QueryClient;

export const createQueryClientRegistry = () => {
  let queryClient: QueryClient | undefined;

  return {
    getOrCreate(createQueryClient: QueryClientFactory) {
      queryClient ??= createQueryClient();

      return queryClient;
    },
    clear() {
      queryClient?.clear();
    },
  };
};

const browserQueryClientRegistry = createQueryClientRegistry();

export const getOrCreateQueryClient = (createQueryClient: QueryClientFactory) =>
  browserQueryClientRegistry.getOrCreate(createQueryClient);

export const clearQueryClient = () => browserQueryClientRegistry.clear();
